<template>
  <v-form
      ref="form"
      lazy-validation
  >
    <v-row>
      <v-col cols="4">
        <v-text-field
            dense
            label="Ordem"
            type="number"
            min="0"
            required
            v-model="shareModel.code"
            :rules="[$util.formrules.required]"
            :error-messages="errors.code"
            outlined
        />
      </v-col>
      <v-col cols="8">
        <v-textarea
            dense
            label="Descrição"
            clear-icon="mdi-close-circle"
            required
            v-model="shareModel.description"
            :rules="[$util.formrules.required]"
            :error-messages="errors.description"
            outlined
        />
      </v-col>
      <v-col cols="4">
        <v-checkbox
            v-if="!!shareModel.id"
            dense
            outlined
            v-model="shareModel.active"
            :false-value="false"
            :true-value="true"
            label="Ativo"
        ></v-checkbox>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    shareModel: {
      type: Object
    },
    errors: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    model() {
      return this.shareModel;
    },
    validate() {
      return this.$refs.form.validate();
    },
    goBack() {
      this.$router.back()
    }
  }
};
</script>


